import Tooltip from '../../common/Tooltip'
import { openModal } from '../../../actions/app'

const mapStateToProps = state => ({})

const RevokeAccessButton = connect(
  mapStateToProps,
  { openModal }
)(({ grant, openModal }) => {
  const revokeButtonRef = useRef()
  const cannotRevokeAccessExplanation =
    "You cannot delete access for a teacher who has class sections with students enrolled. To delete access, first either remove the teacher from the class sections or drop the students from this teacher's sections."

  if (grant.canRevoke)
    return (
      <button
        type="button"
        className="btn-link"
        ref={revokeButtonRef}
        onClick={() =>
          openModal('RevokeTeacherAccessConfirmModal', {
            grant,
            modalCloseFocusElem: revokeButtonRef.current,
          })
        }
      >
        Remove
      </button>
    )

  return (
    <button type="button" className="btn-link" disabled={true}>
      <style>
        {`
          .table tbody tr td div[data-toggle=tooltip] {
            font-size: 1rem!important;
            float: none;
          }
        `}
      </style>
      <Tooltip
        title={cannotRevokeAccessExplanation}
        placement="top"
        container="body"
        label="Teacher revoke access tooltip"
      >
        Remove
      </Tooltip>
    </button>
  )
})

const GrantedAccessTableRow = ({ grant, num }) => {
  const { firstName, lastName, email = '', courseName } = grant
  const fullName = `${firstName} ${lastName}`

  return (
    <tr>
      <td
        style={{
          textAlign: 'center',
          verticalAlign: 'middle',
          ...(num === 0 && { borderTopWidth: 0 }),
        }}
      >
        {fullName}
        {email && (
          <div>
            (<a href={`mailto:${email}`}>{email}</a>)
          </div>
        )}
      </td>
      <td
        style={{
          textAlign: 'center',
          verticalAlign: 'middle',
          ...(num === 0 && { borderTopWidth: 0 }),
        }}
      >
        {courseName}
      </td>
      <td
        style={{
          textAlign: 'center',
          verticalAlign: 'middle',
          ...(num === 0 && { borderTopWidth: 0 }),
        }}
      >
        <RevokeAccessButton grant={grant} />
      </td>
    </tr>
  )
}

export default GrantedAccessTableRow
